<template>
    <v-card elevation="2" height="100%">
        <v-card-text>
            <h2 class="display-1 mb-4">{{ title }}</h2>
            <template> </template>
        </v-card-text>
        <v-card-actions>
            <v-layout justify-end>
                <v-btn @click="getReport" color="primary"> Get {{ title }} </v-btn>
            </v-layout>
        </v-card-actions>
    </v-card>
</template>

<script>
import { mapState } from "vuex";
import collectionsApi from "@/api/collections";

export default {
    components: {},
    computed: {
        ...mapState("userAuth", ["user"]),
    },
    created() {},
    props: {
        title: {
            type: String,
        },
    },
    methods: {
        getReport: function () {
            this.$router.push({
                name: "geoReport",
                query: {
                    /*startDate: this.cfrStartDate,*/
                    /*endDate: this.cfrEndDate,*/
                },
            });
        },

        dateFormatted: function (date) {
            return date ? this.$moment(date).format("dddd, MMMM D") : "";
        },
    },
};
</script>
